

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_awnp233ooz = () => {
                    
                        if (document.querySelector('.beae-hywuxz6y:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-hywuxz6y:not([data-beae-bind])'),
                                
                                id: 'beae-hywuxz6y',
                                isLive: true
                            });
                            document.querySelector('.beae-hywuxz6y:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_awnp233ooz()
                } else {
                    window.beaePageJS.push(jsHandle_awnp233ooz)
                }
            